// extracted by mini-css-extract-plugin
export var infoRow = "_ry-2";
export var labelContainer = "_ry-0";
export var rightInfo = "_ry-1";